// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QSeU","left":"styles_left__2q7PT"};